(function ($, win) {
    'use strict';

    var dk = win.dk || {};

    function openRiPopup(url, alt, title, description, video) {
        var $content,
            $expand,
            titleId = dk.generateId('ri-', title, true),
            descId = dk.generateId('ri-', description, true);


        if (video) {
            $content = $(video).attr({
                'aria-labelledby': titleId,
                'aria-describedby': descId
            });
        }

        else {
            $content = $('<img/>').attr({
                src: url,
                alt: alt,
                'aria-labelledby': titleId,
                'aria-describedby': descId
            });

            $expand = $('<a class="ri-expand" target="_blank"/>').attr('href', url).text('View full-sized image');

            // Add Akamai Image Manager bypass to view full-sized image link
            /* Disabled because Image Manager is not currently in use
            const a = $expand[0];
            a.search += (a.search ? '&' : '?') + 'imbypass=true';
            // */
        }

        return $('<div class="ri-popup"/>').append(
            $('<div class="ri-popup-image"/>').append(
                $content,
                $expand
            ),
            $('<div class="ri-popup-information"/>').append(
                $('<div class="ri-popup-title"/>').attr('id', titleId).append(title),
                $('<div class="ri-popup-description"/>').attr('id', descId).append(description))
        );
        // }
    }

    $(function () {
        $('.ri-gallery').on('keypress click', '.ri-card', function (e) {
            var $card = $(this),
                $img = $card.find('img'),
                $vid = $card.find('.ri-video');
            var imgUrl = $img.attr('src'),
                imgAlt = $img.attr('alt'),
                imgTitle = $card.find('.ri-title').html(),
                imgDesc = $card.find('.ri-description').html(),
                videoFrame = $vid.html();

            if (e.which === 13 || e.type === 'click') {
                var $gallery = $card.parents('.ri-gallery:first');
                if ($gallery.is('[data-navigate-link]')) {
                    var link = $('a[href]:first', $card).prop('href');
                    if (link) {
                        location.href = link;
                    }

                } else {
                    $.magnificPopup.open({
                        items: {
                            src: openRiPopup(imgUrl, imgAlt, imgTitle, imgDesc, videoFrame)
                        },
                        type: 'inline',
                        midClick: true,
                        callbacks: {
                            open: function () {
                                $(this.contentContainer).addClass('ri-popup-container');
                            }
                        }
                    });
                }
            }
        });
    });
})(window.jQuery, window);
